module.exports = __webpack_public_path__ + "img/skipping-jump-rope.d392a258.png";